const XAU = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="1280"
    height="1280"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(969)"
      d="m0 0h112l58 6 46 6 35 6 41 9 32 8 31 9 43 14 42 16 37 16 38 18 25 13 24 14 23 13 23 15 16 10 14 10 18 13 14 10 16 13 13 10 26 22 10 9 8 7 16 15 11 11 8 7 12 13 13 13 7 8 11 12 9 11 10 11 20 25 10 13 14 19 13 19 8 11 13 20 16 26 16 28 11 20 8 16 13 27 16 36 12 30 13 36 10 31 10 35 10 41 8 40 7 45 5 44 4 43v96l-5 58-6 48-4 26-7 37-10 42-10 36-13 41-9 25-11 28-15 35-17 36-16 31-28 48-15 23-9 14-12 17-10 14-12 16-14 18-13 16-12 14-13 15-12 13-15 16-31 31-8 7-9 9-11 9-12 11-11 9-13 11-12 9-15 12-17 12-14 10-27 18-19 12-15 9-21 12-25 14-17 9-23 11-24 11-36 15-41 15-33 11-43 12-42 10-35 7-46 7-52 6-34 3h-100l-52-5-49-6-37-6-48-10-35-9-44-13-35-12-26-10-29-12-35-16-29-14-28-15-24-14-20-12-22-14-20-14-17-12-19-14-10-8-14-11-11-9-14-12-15-13-13-12-8-8-8-7-30-30-7-8-11-11-9-11-10-11-7-8-13-16-13-17-11-14-12-17-13-18-11-17-14-22-9-15-15-26-14-26-17-34-13-29-15-37-14-38-14-44-11-42-9-39-8-45-6-45-6-61v-112l5-50 4-34 7-44 10-48 9-36 11-38 14-41 12-32 18-42 10-22 8-16 13-25 13-23 16-27 9-14 11-17 8-12 13-18 12-17 11-14 12-15 7-9 13-15 9-11 12-13 7-8 7-7 7-8 31-31 8-7 14-13 11-9 11-10 11-9 14-11 15-12 16-12 17-12 20-14 16-10 20-13 29-17 24-13 29-15 32-15 33-14 34-13 47-16 42-12 33-8 39-8 49-8 32-4 41-4z"
      fill="#FB9607"
    />
    <path
      transform="translate(1195,1078)"
      d="m0 0h264l9 2 8 5 8 9 8 16 20 45 15 33 11 25 48 108 18 40 10 24 2 7v13l-4 10-8 9-10 5-5 1h-522l-11-4-8-6-5-7-3-8v-11l4-13 19-42 18-41 18-40 18-41 18-40 18-41 15-33 7-13 4-5 12-6z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(587,1078)"
      d="m0 0h265l10 3 7 5v2l3 1 6 10 10 21 80 180 13 29 12 27 12 28 3 12-1 11-5 10-8 8-8 4-5 1h-522l-10-3-6-4-5-5-5-8-2-8 1-11 6-16 13-29 16-36 19-42 11-25 48-108 7-17 13-26 7-8 10-5z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(892,685)"
      d="m0 0h262l10 2 9 6 7 9 8 16 20 45 18 40 17 38 60 135 8 20 1 5v10l-4 11-8 9-9 5-4 1-505 1-22-1-7-3-6-4-7-8-4-9v-13l6-17 20-45 39-87 60-135 8-16 5-7 8-5z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(612,1142)"
      d="m0 0h214l3 3 18 41 19 42 18 41 18 40 14 32 10 23v2h-413l1-5 13-29 18-41 19-42 18-41 27-60z"
      fill="#FB9607"
    />
    <path
      transform="translate(1221,1142)"
      d="m0 0h214l5 8 14 32 13 29 48 108 18 41 2 6h-413l1-5 9-21 17-38 48-108 13-29 9-20z"
      fill="#FB9607"
    />
    <path
      transform="translate(917,749)"
      d="m0 0h213l3 2 13 30 17 38 16 36 17 38 16 36 11 25 7 16v3h-413l2-6 13-30 19-42 18-41 18-40 16-36 11-24z"
      fill="#FB9607"
    />
    <path
      transform="translate(341,1081)"
      d="m0 0h100l42 1 9 3 8 6 5 6 4 10v13l-4 10-6 8-7 5-10 3h-147l-11-2-9-6-7-8-4-10v-12l5-12 7-8 10-5z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1570,1081)"
      d="m0 0h109l40 1 9 4 8 7 6 9 2 13-2 10-6 10-7 6-9 4-8 1h-143l-10-2-11-7-6-8-3-7v-15l4-10 6-8 8-5 6-2z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(534,595)"
      d="m0 0 10 1 9 4 9 7 10 9 86 86 8 11 3 8v13l-4 10-9 10-11 5h-14l-9-4-11-8-93-93-8-10-4-10v-12l4-11 8-9 12-6z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1018,394)"
      d="m0 0h13l9 4 8 7 5 7 2 6 1 19v132l-2 9-4 8-4 5-9 6-6 2h-14l-10-4-9-8-5-10-1-6v-146l2-11 6-10 7-6z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1508,595)"
      d="m0 0 10 1 8 3 7 5 7 10 2 7v13l-6 12-11 12-93 93-9 6-5 2h-14l-12-5-5-4-6-9-2-5-1-11 3-11 6-8 9-10 93-93 10-6z"
      fill="#FEFEFE"
    />
  </svg>
);
export default XAU;
